import React from "react";
import PropTypes from "prop-types";
import Modal from "./atoms/Modal";

const { varsomeConfig } = window;

function LoginModal(props) {
  const { showModal, toggleModal } = props;
  return (
    <Modal
      isOpen={showModal || false}
      onRequestClose={toggleModal}
      ContentRender={() => {
        return (
          <div className="tw-p-16">
            <h4>You must be signed in to do this</h4>
            <div className="varsome-text-center tw-mt-4">
              <a
                href={`${varsomeConfig.login_url}?next=${encodeURIComponent(
                  window.location.href
                )}`}
              >
                Sign in
              </a>
              <p className="tw-my-2 tw-mx-0">or</p>
              <a href={varsomeConfig.signup_url} className="btn btn-info">
                Join the VarSome community
              </a>
            </div>
          </div>
        );
      }}
    />
  );
}

LoginModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool,
};
LoginModal.defaultProps = {
  showModal: false,
};

export default React.memo(LoginModal);
